<style lang="less">
  @import "./QueryMedia.less";
</style>

<template>
  <div class="query-media">
    <van-cell-group>
      <!--<van-cell title="IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />-->
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
      <van-cell title="摄像头" icon="award-o" :value="cameraType" is-link @click="selectCameraFn" />
      <van-cell title="开始日期" icon="aim" :value="startTime" is-link @click="selectStartTimeFn" />
      <van-cell title="结束日期" icon="aim" :value="endTime" is-link @click="selectEndTimeFn" />
      <van-cell :title="queryType===1?'照片类型':'视频类型'" icon="photo-o" :value="pictureType" is-link @click="selectPictureFn" />
    </van-cell-group>
    <div class="page-btn">
      <van-button type="info" size="large" @click="queryCheckFn">开始查询</van-button>
      <van-button type="info" size="large" plain @click="toHomePageFn">返回首页</van-button>
    </div>
    <van-action-sheet
      v-model="showActionSheetCamera"
      title="请选择摄像头"
      round
      :actions="cameraTypeList"
      cancel-text="取消"
      @select="onSelectCameraFn"
    />
    <van-action-sheet
      v-model="showActionSheetPicture"
      :title="queryType===1?'请选择照片类型':'请选择视频类型'"
      round
      :actions="pictureTypeList"
      cancel-text="取消"
      @select="onSelectPictureFn"
    />
    <van-popup v-model="showPopupStartTime" round position="bottom">
      <van-datetime-picker
        v-model="startTimeDate"
        type="date"
        title="请选择开始日期"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onclosePopupFn"
        @confirm="onSelectStartTimeFn"
      />
    </van-popup>
    <van-popup v-model="showPopupEndTime" round position="bottom">
      <van-datetime-picker
        v-model="endTimeDate"
        type="date"
        title="请选择结束日期"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onclosePopupFn"
        @confirm="onSelectEndTimeFn"
      />
    </van-popup>
  </div>
</template>

<script>
import QueryMedia from './QueryMedia.js'
export default {
  ...QueryMedia
}
</script>
